import { useCallback, useEffect, useRef } from 'react';

export function useClickOutsideRef<T extends HTMLElement>(onClickOutside: () => void) {
  const ref = useRef<T>(null);
  const escapeListener = useCallback((e: KeyboardEvent) => {
    if (e.key === 'Escape') {
      onClickOutside();
    }
  }, [onClickOutside]);
  const clickListener = useCallback(
    (e: MouseEvent) => {
      if (e.target && !(ref.current?.contains(e.target as any))) {
        onClickOutside();
      }
    },
    [onClickOutside],
  );
  useEffect(() => {
    document.addEventListener('click', clickListener);
    document.addEventListener('keyup', escapeListener);
    return () => {
      document.removeEventListener('click', clickListener);
      document.removeEventListener('keyup', escapeListener);
    };
  }, [clickListener, escapeListener]);
  return ref;
}
